export default __webpack_public_path__ + "72f02e850118731f3bf2b6aba2afead3.png";